import { BehaviorSubject, Observable } from 'rxjs'
import { distinctUntilChanged, map } from 'rxjs/operators'

export class StateService<T> {
  private state$: BehaviorSubject<T>

  constructor(initialState: T) {
    this.state$ = new BehaviorSubject<T>(initialState)
  }

  get state(): T {
    return this.state$.getValue()
  }

  protected select<K>(mapFun: (state: T) => K): Observable<K> {
    return this.state$.asObservable().pipe(
      map((state: T) => mapFun(state)),
      distinctUntilChanged()
    )
  }

  protected setState(newState: Partial<T>): void {
    this.state$.next({
      ...this.state,
      ...newState
    })
  }
}
